var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntrude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2048 -2048 2048 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1, -1)",
    d: "M1600 1792q40 0 75 -15t61 -41t41 -61t15 -75v-896q0 -119 -45.5 -224t-123.5 -183t-183 -123.5t-224 -45.5q-144 0 -268.5 55t-225.5 156l-472 472q-28 28 -43 65t-15 76q0 42 16 78.5t43 63.5t63.5 42.5t77.5 15.5q40 0 76 -15.5t65 -43.5l107 -106v741q0 40 15 75 t41 61t61 41t75 15q37 0 71 -14q8 31 26 57t42.5 45t54.5 29.5t62 10.5t62 -10.5t54.5 -29.5t42.5 -45t26 -57q34 14 71 14q32 0 62 -10.5t54.5 -29.5t42.5 -45t26 -57q34 14 71 14zM1664 1600q0 26 -19 45t-45 19t-45 -19t-19 -45v-448q0 -26 -19 -45t-45 -19t-45 19 t-19 45v576q0 26 -19 45t-45 19t-45 -19t-19 -45v-512q0 -26 -19 -45t-45 -19t-45 19t-19 45v640q0 26 -19 45t-45 19t-45 -19t-19 -45v-640q0 -26 -19 -45t-45 -19t-45 19t-19 45v512q0 26 -19 45t-45 19t-45 -19t-19 -45v-787q0 -23 -8.5 -42.5t-23 -34.5t-34.5 -23.5 t-42 -8.5t-42.5 8t-36.5 24l-139 139q-21 21 -50 21t-50.5 -21t-21.5 -51q0 -29 21 -50l472 -473q84 -84 184 -128.5t219 -44.5q93 0 174.5 35.5t142 96t96 142t35.5 174.5v896z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntrude);
export default __webpack_public_path__ + "static/media/intrude.217f6700.svg";
export { ForwardRef as ReactComponent };